import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement, useState, } from 'react';
import Grid, {} from '../grid';
import { FormOptionCardContext } from './FormOptionCardContext';
import FormOptionCardItem, {} from './FormOptionCardItem';
import { FormOptionCardContainer } from './styles/form-option-card.styled';
const FormOptionCard = ({ children, columns = 1, componentNameGA = 'form-option-card', dataTest = 'form-option-card', inputType, name, onChange, preselectedOptions, required = false, textValidationMessages, colorContext = 'on-light', }) => {
    /**
     * For FormOptionBlock of type 'radio', the selected option is stored as a string and not an array, since
     * only one or zero options can be selected in this case. When passing preselectedOptions, the first option in the array is selected.
     */
    const [selectedOptions, setSelectedOptions] = useState(() => {
        if (!preselectedOptions) {
            return [];
        }
        if (inputType === 'radio') {
            return preselectedOptions[0];
        }
        return [...preselectedOptions];
    });
    const onChangeHandler = (event) => {
        const selected = event.target;
        let newOptions;
        if (inputType === 'checkbox') {
            if (!selectedOptions.includes(selected.value) && selected.checked) {
                newOptions = [...selectedOptions, selected.value];
            }
            else if (selectedOptions.includes(selected.value) && !selected.checked) {
                newOptions = selectedOptions.filter((e) => e !== selected.value);
            }
        }
        else if (inputType === 'radio') {
            newOptions = selected.value;
        }
        if (newOptions !== undefined) {
            setSelectedOptions(newOptions);
            if (onChange)
                onChange(newOptions);
        }
    };
    function isChecked(value) {
        if (inputType === 'radio') {
            return value === selectedOptions;
        }
        return selectedOptions.includes(value);
    }
    /** Add the checked status and index for each child */
    const childrenWithIndex = Children.map(children, (child, index) => {
        if (isValidElement(child)) {
            return cloneElement(child, {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                checked: isChecked(child.props.value),
                index,
            });
        }
        return child;
    });
    return (_jsx(FormOptionCardContext.Provider, { value: {
            componentNameGA,
            dataTest,
            inputType,
            name,
            onChange: onChangeHandler,
            required,
            textValidationMessages,
            colorContext,
        }, children: _jsx(FormOptionCardContainer, { dataTest: dataTest, reference: name, colorContext: colorContext, children: _jsx(Grid, { columns: columns, equalHeight: true, children: childrenWithIndex }) }) }));
};
FormOptionCard.Item = FormOptionCardItem;
export default FormOptionCard;
